import { c as _c } from "react/compiler-runtime";
import { useAdvisorsAttention } from '@src/components/sco/Advisors/hooks/useAdvisorsAttention';
import { formatAttentionCount } from '@src/components/sco/Advisors/utils/advisorsAttention';
import { NavItem } from '@src/components/sco/nav/ScoSiteNavBar/index';
import React from 'react';
import { MdChat } from 'react-icons/md';

/**
 * Site Chat icon → `/inbox`.
 *
 * Reads `messagesUnread` from the shared W3 payload (same number as
 * `directChatThreadsUnreadCommentsCount`: direct-chat plus Wil-AI tool-chat). Advisor DMs light both
 * this icon and the site Advisors item (L22). Session chat never counts here.
 */
export const ChatSiteNavBarItem = () => {
  const $ = _c(5);
  const {
    attention
  } = useAdvisorsAttention();
  let t0;
  if ($[0] !== attention.messagesUnread) {
    t0 = formatAttentionCount(attention.messagesUnread);
    $[0] = attention.messagesUnread;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const label = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "aria-label": "Chat",
      children: <MdChat />,
      fontSize: "1em",
      href: "/inbox",
      padding: 0,
      variant: "ghost",
      width: "auto"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== label) {
    t2 = <NavItem {...{
      buttonProps: t1,
      ...(label ? {
        badgeProps: {
          fontSize: "11px",
          variant: "count",
          position: "absolute",
          right: "-2",
          textAlign: "center",
          children: <>{label}</>
        }
      } : {})
    }} />;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};